import oneLine from 'common-tags/lib/oneLine';

/**
 * Обрезает текст и вставляет троеточие
 *
 * @param {string} text
 * @param {number} limit
 */

export default function cutDown(text, limit = 120, wholeWords) {
  const str = oneLine`${text}`;

  if (str.length <= limit) {
    return str;
  }

  const { parts } = str
    .split(/\s/)
    .reduce((result, word) => {
      if (result.length < limit) {
        const newLength = result.length + word.length;
        if (newLength > limit) {
          if (!wholeWords) {
            result.parts.push(word.slice(0, limit - result.length));
          }
        } else {
          result.parts.push(word);
        }
        result.length = newLength + 1;
      }

      return result;
    }, { parts: [], length: 0 });

  return `${parts.join(' ')}...`;
}

export function cutDownMultiline(text, limit = 120) {
  if (text.length <= limit) {
    return text;
  }

  return `${text.slice(0, limit)}...`;
}
